import { Reducer } from "redux";

import { DisciplineTemplateNotesResponse } from "../models/Api/Notes";
import { ReferralTemplateNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { MasterReferralTemplateNotesActionDispatchTypes } from "../constants/Notes";

export const initialState: DisciplineTemplateNotesResponse = {
  loading: false,
  response: [],
};

const MasterReferralTemplateNotesReducer: Reducer<
  DisciplineTemplateNotesResponse,
  ReferralTemplateNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterReferralTemplateNotesActionDispatchTypes.REFERRAL_NOTES_TEMPLATES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterReferralTemplateNotesActionDispatchTypes.REFERRAL_NOTES_TEMPLATES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterReferralTemplateNotesReducer;
